import { Toaster } from "react-hot-toast";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ControlPanel from "./components/testing/ControlPanel";
import Navbar from "./components/Navbar";
import UserContextProvider from "./context/UserContext";
import DeviceConfig from "./components/device/page";
import Login from "./components/Login";
import Debug from "./components/Debug";
import DebugContextProvider from "./context/DebugContext";
import { Helmet } from "react-helmet";
import DeviceParamsForm from './components/forms/DeviceParamsForm';
import OtaUpdateForm from './components/forms/OtaUpdateForm';
import WaterQualityParameters from './components/WaterQualityParameters';
import PCBTesting from './components/pcb-testing/index';
import DeviceRegistration from './components/device-registration/index';
import FilterConfsDashboard from './components/filter-confs/FilterConfsDashboard';
import FilterConfigForm from './components/filter-confs/FilterConfigForm';
import AddFilterTypePage from './components/filter-confs/AddFilterTypePage';
import ProductDetails from './components/filter-confs/ProductDetails';
import AddCustomerPage from "./components/AddCustomerPage";

function App() {
  return (
    <BrowserRouter>
      <UserContextProvider>
        <DebugContextProvider>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Integration Script</title>
          </Helmet>
          <div className="App flex h-screen overflow-hidden bg-gray-100">
            <Navbar />
            <main className="flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden">
              <Routes>
                <Route path="/" element={<Navigate to="/testing" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/testing" element={<ControlPanel />} />
                <Route path="/device" element={<DeviceConfig />} />
                <Route path="/devicetesting" element={<DeviceParamsForm />} />
                <Route path="/debug" element={<Debug />} />
                <Route path="/ota-update" element={<OtaUpdateForm />} />
                <Route path="/water-quality-parameters" element={<WaterQualityParameters />} />
                <Route path="/pcb-testing" element={<PCBTesting />} />
                <Route path="/device-registration" element={<DeviceRegistration />} />
                <Route path="/filter-confs" element={<FilterConfsDashboard />} />
                <Route path="/filter-confs/add" element={<AddFilterTypePage />} />
                <Route path="/filter-confs/add/:type" element={<FilterConfigForm />} />
                <Route path="/filter-confs/details/:productId" element={<ProductDetails />} />
                <Route path="/add-customer" element={<AddCustomerPage />} />
              </Routes>
            </main>
          </div>
          <Toaster position="top-right" />
        </DebugContextProvider>
      </UserContextProvider>
    </BrowserRouter>
  );
}

export default App;
